"use client";
import Tab from "./Tab";
import Menu from "./Menu";

const NavWrap = () => {
    return(
        <>
            <Tab />
            <Menu />
        </>
    );
}

export default NavWrap;